// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__YUqIB","spinner":"ClaimDepartment_spinner__iTuSb"};